"use strict"

import moment from "moment"
import i18n from "@/plugins/i18n"

export const reportFileType = (format) => {
  return format?.id === "dreport_export" ? "xlsx" : "pdf"
}

export const reportFormatString = (reportFormat) => {
  return reportFormat.id + ((!reportFormat.lang || reportFormat.lang == "ja") ? "" : "_" + reportFormat.lang)
}

export const discussionReportBaseName = (discussion) => {
  const recordedAt = moment(discussion?.recordedAt).format("YYYYMMDD-HHmm")
  const groupname = discussion?.group?.name || discussion?.recorder?.name || ""
  const topic = discussion?.topic ? `_${discussion.topic}` : ""
  return `${recordedAt}_${groupname}${topic}`
}

export const buildDiscussionReportName = (discussion, format) => {
  const filetype = reportFileType(format)
  const formatName = i18n.t(format.name)
  const basename = discussionReportBaseName(discussion)
  return `${basename}_${formatName}.${filetype}`
}

// 印刷（PDF 保存）時のファイル名初期値は document.title。他レポートと命名を揃えるため
// 同じベース名 + モード名にする。拡張子はブラウザが付与するので含めない。
export const buildDiscussionPrintTitle = (discussion, modeName) => {
  return `${discussionReportBaseName(discussion)}_${modeName}`
}

export const sanitizeFileName = (name) => {
  return String(name || "").replace(/[\\/:*?"<>|]/g, "_")
}

export const buildDiscussionReportDownloadName = (discussion, format) => {
  return sanitizeFileName(buildDiscussionReportName(discussion, format))
}

export const buildDiscussionBulkZipName = (courseName, formatName, unknownCourseLabel) => {
  const timestamp = moment().format("YYYYMMDD-HHmm")
  const coursePart = courseName || unknownCourseLabel || "reports"
  return sanitizeFileName(`${coursePart}_${formatName}_${timestamp}.zip`)
}

export const downloadBlobByAnchor = (blob, fileName, revokeDelayMs = 500) => {
  let url = null
  let a = null

  try{
    url = URL.createObjectURL(blob)
    a = document.createElement("a")
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
  } finally {
    if(a?.parentNode) a.parentNode.removeChild(a)
    if(url) setTimeout(() => URL.revokeObjectURL(url), revokeDelayMs)
  }
}
